import React from 'react';

export default function QueryList(props) {
  return (
    <div className="btn-group" style={{ marginBottom: 10 }}>
      <button
        className="btn btn-default dropdown-toggle"
        data-toggle="dropdown"
      >
        <i className="fa fa-list fa-lg" /> Saved Queries
      </button>
      <ul className="dropdown-menu dropdown-menu-xs pull-right">
        {props.queries &&
          props.queries.map((el, i) => (
            <li key={i} onClick={() => props.applyFilter(el.query)}>
              <a>{el.title}</a>
            </li>
          ))}
      </ul>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/management/components/QueryBuilder/QueryList.js